import styled from '@emotion/styled';

export const TableContainer = styled.div`
  .ui-table-row {
    cursor: pointer;
  }
`;

export const Name = styled.span`
  font-weight: 600;
  /* Shrink before the Archived marker instead of pushing it out of the cell. */
  min-width: 0;
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
